<style lang="less" scoped></style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="120px"
          class="detail-form">
          <div class="flex detail-form-parent-div">
            <div class="flex">
              <el-form-item class="detail-from-input" label="车辆品牌名称" prop="vehicleBrand">
                <el-input v-model="detailForm.vehicleBrand" size="small"></el-input>
              </el-form-item>
              <el-form-item class="detail-from-input" label="备注" prop="specificationName">
                <el-input v-model="detailForm.remark" size="small"></el-input>
              </el-form-item>
              <el-form-item class="detail-from-input detail-body-title" label="状态" prop="status">
                <el-radio-group v-model="detailForm.status">
                  <el-radio label="01">启用</el-radio>
                  <el-radio label="02">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig,
      editFlag: false,
      pageTitle: '车辆品牌新增',
      // 默认值设置
      detailForm: {},
      hideUpload: false,//上传图片按钮
      imageUrl: "",//图片储存
      dialogImageUrl: null,//图片地址
      dialogVisible: false,

      chargingSpeed: [], // 充电速度
      chargingType: [], // 电流输出类型
      interfaceType: [], // 接口类型
      businessBelongList: [], // 业务归属
      useStateList: [], // 系统状态
      warrantyTimeList: [], // 质保有效期
      networkTimeList: [], // 联网订阅
      phaseList: [], // 单相桩、三相桩
      audioFrequencyList: [], // 音频
      networkList: [], // 联网方式

    }
  },
  created() {
    this.init()
  },
  methods: {

    //判断是否为编辑模式
    init() {
      let _ = this;
      if (_.$store.state.editId) {
        _.editFlag = true;
        _.pageTitle = '车辆品牌编辑';
        console.log(_.$route);
        _.detailForm = _.$route.query.brandInfo;
      }
    },

    // 表单提交
    submitForm(formName) {
      let _ = this
      _.detailForm.corpNo = _.$store.state.corpNo;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (_.editFlag) {
            _.$H.post(_, _.$A.digitization.vehicleBrandEdit, _.detailForm).then(res => {
              if (res.status === 200) {
                _.$router.push({
                  name: pageConfig.listRouter
                });
              }
            })
          } else {
            _.$H.post(_, _.$A.digitization.vehicleBrandAdd, _.detailForm).then(res => {
              if (res.status === 200) {
                _.$router.push({
                  name: pageConfig.listRouter
                });
              }
            })
          }
        }
      })
    },

    // 取消
    resetForm() {
      this.$router.push({
        name: pageConfig.listRouter,
      })
    },
  },
}
</script>
